import api from "./index";

export const dashboardAPI = {
  getOverview: () => api.get("/dashboard/overview"),
  getProjectDashboard: (id) => api.get(`/dashboard/project/${id}`),
  getStockAlerts: () => api.get("/dashboard/stock-alerts"),
  getLaborSummary: () => api.get("/dashboard/labor-summary"),
};
